import { render, staticRenderFns } from "./SpeechExplainView.vue?vue&type=template&id=35a0ed89&scoped=true"
import script from "./SpeechExplainView.vue?vue&type=script&lang=js"
export * from "./SpeechExplainView.vue?vue&type=script&lang=js"
import style0 from "./SpeechExplainView.vue?vue&type=style&index=0&id=35a0ed89&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a0ed89",
  null
  
)

export default component.exports